import { Box, Tooltip } from "@mui/material";
import { forwardRef } from "react";

interface TrancateTextProps {
  line?: number;
  text: string;
  sx?: any;
}
const TruncateText: React.FC<TrancateTextProps> = forwardRef(
  ({ line = 1, text, sx, ...other }, ref) => {
    const style = {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: line,
      WebkitBoxOrient: "vertical",
      ...sx,
    };

    return (
      <Tooltip title={text}>
        <Box ref={ref} sx={{ ...style }} {...other}>
          {text}
        </Box>
      </Tooltip>
    );
  }
);

export default TruncateText;
